import { DropDownList } from "@progress/kendo-react-dropdowns";
import { InputField } from "../../components/form/input.field.component";
import { API_END_POINT } from "../../constants";
import {
  FormikModelDialog,
  SubmitStatus,
} from "../../core/formik-model-dialog.component";
import WardModel from "../../models/masters/ward-model";
import * as Yup from "yup";
import { useEffect, useState } from "react";
import { useGetWards } from "../../apiclient/master/useGetWardApi";
import { SelectField } from "../../core/select-field.component";
import { useGetConstituency } from "../../apiclient/master/useGetConstituencyApi";
import { useGetCorporationZone } from "../../apiclient/master/useGetCorporationZoneApi";

interface WardEditProps {
  data: WardModel;
  isViewMode?: boolean;
  onClose?: (status: SubmitStatus, data: any) => any;
}

const WardEntry: React.FC<WardEditProps> = ({ ...props }) => {
  let { data, onClose,isViewMode } = props;
  const title = data?.wardId > 0 ? "Edit Ward" : "Add Ward";

  let initialValue: WardModel = {
    wardId: data?.wardId ? data.wardId : 0,
    name: data?.name,
  };
  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .required("Required")
      .test("check-duplicate-name", "Ward name already exists", (value) => {
        // Ensure the value is compared in a case-insensitive manner
        return (
          (value &&
            !existingName.some(
              (existing) => existing.toLowerCase() === value.toLowerCase()
            )) ||
          (data?.name && value === data.name) // Allow current name during update
        );
      }),
  });
  console.log(initialValue);

  const [existingName, setExistingName] = useState<string[]>([]); // state to hold existing zone names
  const { data: fetchedWard } = useGetWards(); // Fetching existing zones data

  useEffect(() => {
    if (fetchedWard) {
      setExistingName(fetchedWard.map((zone: any) => zone.name)); // Extracting zone names to compare against
    }
  }, [fetchedWard]);

  const [constituencyData, setConstituencyData] = useState<
    { value: string; label: string }[]
  >([]);
  const [corporationZoneData, setCorporationZoneData] = useState<
    { value: string; label: string }[]
  >([]);
  const { data: fetchedConstituency } = useGetConstituency();
  const { data: fetchedCorporationZone } = useGetCorporationZone();

  useEffect(() => {
    if (fetchedConstituency) {
      const mappedConstituency = fetchedConstituency.map(
        (constituency: any) => ({
          value: constituency.constituencyId.toString(),
          label: constituency.name,
        })
      );
      setConstituencyData(mappedConstituency);
    }
    if (fetchedCorporationZone) {
      const mappedCorporationZone = fetchedCorporationZone.map(
        (corporationzone: any) => ({
          value: corporationzone.corporationZoneId.toString(),
          label: corporationzone.name,
        })
      );
      setCorporationZoneData(mappedCorporationZone);
    }
  }, [fetchedConstituency, fetchedCorporationZone]);

  return (
    <>
      <FormikModelDialog
        width="50%"
        title={title}
        initialData={initialValue}
        validationSchema={validationSchema}
        show={!!data}
        onClose={onClose}
        endpoint={API_END_POINT.MASTER}
        showAddAnother={true}
        postRoute="Ward/SaveWard"
        isViewOnly ={isViewMode}
        isUpDateEntityDetails={data?.wardId > 0 ? true : false}
      >
        <div>
          <div className="row">
            <div className="col-12">
              <InputField maxLength={100} label="Ward *" name="name" />
            </div>
          </div>
        </div>
      </FormikModelDialog>
    </>
  );
};

export default WardEntry;
